import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Carrusel360 from '../components/Carrusel360';

// IMPORTAMOS IMÁGENES LOCALES
import bosqueImg from '../assets/bosque.jpg';
import fincaImg from '../assets/finca.jpg';
import cataImg from '../assets/cata.jpg';
import xicotepecImg from '../assets/xicotepec.jpg';
import procesadoraImg from '../assets/procesadora.jpg';
import cocinaHumoImg from '../assets/cocina-humo.jpg';
import romanImg from '../assets/roman-catador.jpg';

const Tours = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    date: '',
    people: '2',
    message: '',
    includeBuffet: false,
    includeCatacion: true,
    includeRecorrido: true
  });

  const [activeTab, setActiveTab] = useState('info');

  const handleSubmit = (e) => {
    e.preventDefault();
    
    const numPersonas = parseInt(formData.people);
    const costoCatacion = formData.includeCatacion ? 200 * numPersonas : 0;
    const costoRecorrido = formData.includeRecorrido ? 150 * numPersonas : 0;
    const costoTourCompleto = formData.includeCatacion && formData.includeRecorrido ? 300 * numPersonas : costoCatacion + costoRecorrido;
    const costoBuffet = formData.includeBuffet && numPersonas >= 10 ? 200 * numPersonas : 0;
    const costoTotal = costoTourCompleto + costoBuffet;

    let mensaje = `¡Gracias por tu interés en visitar nuestra finca!\n\n`;
    mensaje += `📍 **Xicotepec de Juárez, Pueblo Mágico**\n`;
    mensaje += `🌲 **Sierra Norte de Puebla**\n\n`;
    mensaje += `📋 **RESUMEN DE TU RESERVACIÓN**\n`;
    mensaje += `━━━━━━━━━━━━━━━━━━━━━━━━\n\n`;
    mensaje += `👤 Nombre: ${formData.name}\n`;
    mensaje += `📧 Email: ${formData.email}\n`;
    mensaje += `📞 Teléfono: ${formData.phone}\n`;
    mensaje += `📅 Fecha: ${formData.date || 'Por definir'}\n`;
    mensaje += `👥 Personas: ${formData.people}\n\n`;
    
    mensaje += `💰 **DETALLE DE COSTOS**\n`;
    mensaje += `━━━━━━━━━━━━━━━━━━\n`;
    if (formData.includeCatacion) {
      mensaje += `🎫 Taller de Catación: $${200 * numPersonas} MXN\n`;
    }
    if (formData.includeRecorrido) {
      mensaje += `🌿 Recorrido por el cafetal: $${150 * numPersonas} MXN\n`;
    }
    if (formData.includeCatacion && formData.includeRecorrido) {
      mensaje += `🎟️ Tour Completo (ahorro): $${300 * numPersonas} MXN\n`;
    }
    
    if (formData.includeBuffet) {
      if (numPersonas >= 10) {
        mensaje += `🍽️ Cocina Tradicional de Humo: $${costoBuffet} MXN\n`;
      } else {
        mensaje += `⚠️ Cocina de humo no incluida (mínimo 10 personas)\n`;
      }
    }
    
    mensaje += `\n💵 **TOTAL ESTIMADO: $${costoTotal} MXN**\n\n`;
    mensaje += `━━━━━━━━━━━━━━━━━━━━━━━━\n`;
    mensaje += `Te contactaremos en máximo 24 horas para confirmar disponibilidad.\n`;
    mensaje += `\n¡Gracias por elegir Román Valderrábano El Catador! ☕`;

    alert(mensaje);
    console.log('Tour reservado:', formData);
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const toursDisponibles = [
    {
      id: 1,
      nombre: 'Tour Completo',
      duracion: '4 horas',
      incluye: ['Recorrido por cafetal en bosque mesófilo', 'Taller de catación con Q Grader', 'Degustación de 5 cafés', 'Recuerdo artesanal'],
      precio: 300,
      imagen: fincaImg,
      disponible: true
    },
    {
      id: 2,
      nombre: 'Solo Recorrido',
      duracion: '2 horas',
      incluye: ['Recorrido por cafetal', 'Explicación del proceso', 'Degustación básica'],
      precio: 200,
      imagen: bosqueImg,
      disponible: true
    },
    {
      id: 3,
      nombre: 'Taller de Catación',
      duracion: '1.5 horas',
      incluye: ['Taller con Román Valderrábano, El Catador', 'Cata de 5 variedades', 'Certificado de participación'],
      precio: 150,
      imagen: cataImg,
      disponible: true
    },
    {
      id: 4,
      nombre: 'Cocina Tradicional de Humo',
      duracion: '2 horas',
      incluye: ['Experiencia en ollas de barro', 'Técnicas ancestrales de humo', 'Maridaje con cafés', 'Postre especial'],
      precio: 200,
      imagen: cocinaHumoImg,
      disponible: true,
      minimo: 10
    }
  ];

  return (
    <div className="tours-page">
      {/* Hero Section */}
      <section className="tours-hero" style={{backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${xicotepecImg})`}}>
        <div className="tours-hero-overlay"></div>
        <div className="tours-hero-content">
          <h1>Conoce Nuestro Recorrido</h1>
          <p>Vive el fascinante mundo del café en la Sierra Norte de Puebla</p>
          <div className="hero-location">
            <span>📍 Xicotepec de Juárez, Pueblo Mágico</span>
            <span>🌲 Bosque Mesófilo de Montaña</span>
          </div>
          <button 
            className="btn-primary"
            onClick={() => document.getElementById('reserva-form')?.scrollIntoView({ behavior: 'smooth' })}
          >
            Reservar Ahora
          </button>
        </div>
      </section>

      {/* Tabs de navegación */}
      <div className="tours-tabs">
        <button 
          className={`tab-btn ${activeTab === 'info' ? 'active' : ''}`}
          onClick={() => setActiveTab('info')}
        >
          Información
        </button>
        <button 
          className={`tab-btn ${activeTab === 'tours' ? 'active' : ''}`}
          onClick={() => setActiveTab('tours')}
        >
          Tours Disponibles
        </button>
        <button 
          className={`tab-btn ${activeTab === 'galeria' ? 'active' : ''}`}
          onClick={() => setActiveTab('galeria')}
        >
          Galería
        </button>
        <button 
          className={`tab-btn ${activeTab === 'reserva' ? 'active' : ''}`}
          onClick={() => setActiveTab('reserva')}
        >
          Reservar
        </button>
      </div>

      {/* Contenido de tabs */}
      <div className="tabs-content">
        {/* Tab Información */}
        {activeTab === 'info' && (
          <section className="tours-info-section">
            <div className="tours-info-container">
              <div className="tours-info-grid">
                <div className="tours-info-text">
                  <h2>Conoce Nuestra Finca en la Sierra Norte</h2>
                  <p>
                    Nos encontramos en las montañas de <strong>Xicotepec de Juárez, Pueblo Mágico</strong>, 
                    en la Sierra Norte de Puebla. Nuestra finca está enclavada en un 
                    <strong> bosque mesófilo de montaña</strong>, clima ideal para producir uno de los mejores cafés del país.
                  </p>
                  <p>
                    <strong>ROMÁN VALDERRÁBANO, EL CATADOR</strong>, te invita a conocer el proceso completo, desde 
                    la semilla hasta la taza, con la experiencia de 5 generaciones y su certificación como Q Grader.
                  </p>
                  
                  <div className="tours-highlights">
                    <div className="highlight-item">
                      <span className="highlight-icon">🌿</span>
                      <h4>Recorrido en Bosque Mesófilo</h4>
                      <p>Acompañados por guías especializados, conocerás el ecosistema único donde crece nuestro café</p>
                    </div>
                    <div className="highlight-item">
                      <span className="highlight-icon">👃</span>
                      <h4>Taller de Catación con Román</h4>
                      <p>Aprende a identificar notas y aromas con un catador Q Grader certificado</p>
                    </div>
                    <div className="highlight-item">
                      <span className="highlight-icon">🏭</span>
                      <h4>Proceso de Tostado</h4>
                      <p>Descubre cómo transformamos el grano en café de especialidad</p>
                    </div>
                    <div className="highlight-item">
                      <span className="highlight-icon">🍽️</span>
                      <h4>Cocina Tradicional de Humo</h4>
                      <p>Degusta nuestra gastronomía en ollas de barro con técnicas ancestrales</p>
                    </div>
                  </div>

                  <div className="tours-quote">
                    <blockquote>
                      "Cada visita es única, compartimos nuestra pasión por el café con quienes llegan a nuestra casa en la montaña"
                    </blockquote>
                    <cite>- Román Valderrábano, El Catador</cite>
                  </div>
                </div>

                <div className="tours-info-image">
                  <img 
                    src={romanImg} 
                    alt="Román Valderrábano, El Catador"
                  />
                  <div className="image-badge">
                    <span>🌱</span>
                    Fundada en 1880 - 5 Generaciones
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}

        {/* Tab Tours Disponibles */}
        {activeTab === 'tours' && (
          <section className="tours-available-section">
            <div className="tours-available-container">
              <h2>Experiencias en la Montaña</h2>
              <p>Selecciona la experiencia que más se adapte a tus intereses</p>

              <div className="tours-cards-grid">
                {toursDisponibles.map(tour => (
                  <div key={tour.id} className="tour-card">
                    <div className="tour-card-image">
                      <img src={tour.imagen} alt={tour.nombre} />
                      {tour.minimo && (
                        <span className="tour-minimo-badge">Mínimo {tour.minimo} personas</span>
                      )}
                    </div>
                    <div className="tour-card-content">
                      <h3>{tour.nombre}</h3>
                      <p className="tour-duracion">⏱️ Duración: {tour.duracion}</p>
                      <ul className="tour-incluye">
                        {tour.incluye.map((item, index) => (
                          <li key={index}> {item}</li>
                        ))}
                      </ul>
                      <div className="tour-card-footer">
                        <span className="tour-precio">${tour.precio} MXN</span>
                        <button 
                          className="btn-small"
                          onClick={() => {
                            setActiveTab('reserva');
                            if (tour.nombre === 'Tour Completo') {
                              setFormData(prev => ({...prev, includeCatacion: true, includeRecorrido: true}));
                            } else if (tour.nombre === 'Solo Recorrido') {
                              setFormData(prev => ({...prev, includeCatacion: false, includeRecorrido: true}));
                            } else if (tour.nombre === 'Taller de Catación') {
                              setFormData(prev => ({...prev, includeCatacion: true, includeRecorrido: false}));
                            } else if (tour.nombre === 'Cocina Tradicional de Humo') {
                              setFormData(prev => ({...prev, includeBuffet: true}));
                            }
                          }}
                        >
                          Seleccionar
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>
        )}

        {/* Tab Galería */}
        {activeTab === 'galeria' && (
          <section className="tours-galeria-section">
            <div className="tours-galeria-container">
              <h2>Galería de la Finca</h2>
              <p>Conoce nuestros espacios a través de estas imágenes</p>

              <div className="tours-360-preview">
                <h3>Recorrido Virtual 360° por el Bosque Mesófilo</h3>
                <Carrusel360 />
              </div>

              <div className="galeria-grid">
                <div className="galeria-item">
                  <img src={bosqueImg} alt="Bosque mesófilo" />
                  <div className="galeria-caption">Bosque mesófilo de montaña</div>
                </div>
                <div className="galeria-item">
                  <img src={fincaImg} alt="Finca cafetalera" />
                  <div className="galeria-caption">Nuestra finca en la montaña</div>
                </div>
                <div className="galeria-item">
                  <img src={procesadoraImg} alt="Procesadora" />
                  <div className="galeria-caption">Procesadora de café</div>
                </div>
                <div className="galeria-item">
                  <img src={cataImg} alt="Catación" />
                  <div className="galeria-caption">Taller de catación con Román</div>
                </div>
                <div className="galeria-item">
                  <img src={cocinaHumoImg} alt="Cocina de humo" />
                  <div className="galeria-caption">Cocina tradicional de humo</div>
                </div>
                <div className="galeria-item">
                  <img src={xicotepecImg} alt="Xicotepec" />
                  <div className="galeria-caption">Xicotepec de Juárez, Pueblo Mágico</div>
                </div>
              </div>
            </div>
          </section>
        )}

        {/* Tab Reserva */}
        {activeTab === 'reserva' && (
          <section id="reserva-form" className="tours-reserva-section">
            <div className="tours-reserva-container">
              <div className="reserva-header">
                <h2>Reserva tu Experiencia en la Montaña</h2>
                <p>Completa el formulario y te contactaremos para confirmar</p>
              </div>

              <div className="reserva-grid">
                <div className="reserva-info">
                  <div className="info-card">
                    <h3>📍 Xicotepec de Juárez, Pueblo Mágico</h3>
                    <p>Sierra Norte de Puebla - Bosque Mesófilo de Montaña</p>
                    <ul>
                      <li>🌿 Reservaciones con 48 horas de anticipación</li>
                      <li>👥 Grupos máximos de 15 personas</li>
                      <li>🍽️ Cocina de humo: mínimo 10 personas</li>
                      <li>👗 Ropa cómoda y zapatos para caminar</li>
                    </ul>
                  </div>

                  <div className="precios-card">
                    <h3>Precios</h3>
                    <div className="precio-item">
                      <span>Tour Completo</span>
                      <span className="precio">$300 MXN</span>
                    </div>
                    <div className="precio-item">
                      <span>Solo Recorrido</span>
                      <span className="precio">$150 MXN</span>
                    </div>
                    <div className="precio-item">
                      <span>Taller de Catación</span>
                      <span className="precio">$200 MXN</span>
                    </div>
                    <div className="precio-item highlight">
                      <span>Cocina Tradicional de Humo</span>
                      <span className="precio">$200 MXN</span>
                    </div>
                    <p className="precio-nota">*Cocina de humo: mínimo 10 personas</p>
                  </div>
                </div>

                <div className="reserva-form-container">
                  <form onSubmit={handleSubmit} className="reserva-form">
                    <div className="form-group">
                      <label>Nombre completo *</label>
                      <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        required
                        placeholder="Ej: Juan Pérez García"
                      />
                    </div>

                    <div className="form-row">
                      <div className="form-group">
                        <label>Email *</label>
                        <input
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={handleInputChange}
                          required
                          placeholder="correo@ejemplo.com"
                        />
                      </div>
                      <div className="form-group">
                        <label>Teléfono *</label>
                        <input
                          type="tel"
                          name="phone"
                          value={formData.phone}
                          onChange={handleInputChange}
                          required
                          placeholder="2281234567"
                        />
                      </div>
                    </div>

                    <div className="form-row">
                      <div className="form-group">
                        <label>Fecha preferente *</label>
                        <input
                          type="date"
                          name="date"
                          value={formData.date}
                          onChange={handleInputChange}
                          min={new Date().toISOString().split('T')[0]}
                          required
                        />
                      </div>
                      <div className="form-group">
                        <label>Número de personas *</label>
                        <select
                          name="people"
                          value={formData.people}
                          onChange={handleInputChange}
                          required
                        >
                          {[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15].map(num => (
                            <option key={num} value={num}>{num} {num === 1 ? 'persona' : 'personas'}</option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="form-group checkbox-group">
                      <label className="checkbox-label">
                        <input
                          type="checkbox"
                          name="includeCatacion"
                          checked={formData.includeCatacion}
                          onChange={handleInputChange}
                        />
                        <span>Incluir Taller de Catación con Román ($200 MXN por persona)</span>
                      </label>
                    </div>

                    <div className="form-group checkbox-group">
                      <label className="checkbox-label">
                        <input
                          type="checkbox"
                          name="includeRecorrido"
                          checked={formData.includeRecorrido}
                          onChange={handleInputChange}
                        />
                        <span>Incluir Recorrido por el cafetal en bosque mesófilo ($150 MXN por persona)</span>
                      </label>
                    </div>

                    {formData.includeCatacion && formData.includeRecorrido && (
                      <div className="tour-completo-info">
                        ✨ Tour Completo: $300 MXN por persona (ahorras $50 MXN)
                      </div>
                    )}

                    <div className="form-group checkbox-group">
                      <label className="checkbox-label">
                        <input
                          type="checkbox"
                          name="includeBuffet"
                          checked={formData.includeBuffet}
                          onChange={handleInputChange}
                        />
                        <span>Agregar Cocina Tradicional de Humo ($200 MXN extra por persona)</span>
                      </label>
                      {formData.includeBuffet && parseInt(formData.people) < 10 && (
                        <div className="form-warning">
                          ⚠️ La cocina de humo requiere mínimo 10 personas
                        </div>
                      )}
                    </div>

                    <div className="form-group">
                      <label>Comentarios adicionales</label>
                      <textarea
                        name="message"
                        value={formData.message}
                        onChange={handleInputChange}
                        rows="4"
                        placeholder="¿Alguna pregunta o requerimiento especial?"
                      ></textarea>
                    </div>

                    <div className="resumen-costos">
                      <h4>Resumen de costos:</h4>
                      {(() => {
                        const num = parseInt(formData.people);
                        const catacion = formData.includeCatacion ? 200 * num : 0;
                        const recorrido = formData.includeRecorrido ? 150 * num : 0;
                        const buffet = (formData.includeBuffet && num >= 10) ? 200 * num : 0;
                        const total = catacion + recorrido + buffet;
                        return (
                          <>
                            {formData.includeCatacion && <p>Catación: ${catacion} MXN</p>}
                            {formData.includeRecorrido && <p>Recorrido: ${recorrido} MXN</p>}
                            {formData.includeBuffet && num >= 10 && <p>Cocina de humo: ${buffet} MXN</p>}
                            {formData.includeBuffet && num < 10 && <p className="warning">Cocina de humo no disponible (mínimo 10 personas)</p>}
                            <p className="total"><strong>Total estimado: ${total} MXN</strong></p>
                          </>
                        );
                      })()}
                    </div>

                    <button type="submit" className="btn-submit btn-large">
                      Reservar Ahora
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </section>
        )}
      </div>
    </div>
  );
};

export default Tours;